function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9998 34.8334C27.7443 34.8334 34.8332 27.7446 34.8332 19.0001C34.8332 10.2556 27.7443 3.16675 18.9998 3.16675C10.2553 3.16675 3.1665 10.2556 3.1665 19.0001C3.1665 27.7446 10.2553 34.8334 18.9998 34.8334ZM23.1135 16.6249C22.1448 14.9471 16.8103 12.0885 14.9168 11.1116C14.5994 10.9479 14.2268 11.163 14.2099 11.5197C14.1092 13.648 13.9176 19.6971 14.8862 21.3749C15.8549 23.0527 21.1894 25.9112 23.0829 26.8882C23.4003 27.0519 23.7729 26.8368 23.7898 26.4801C23.8905 24.3518 24.0821 18.3027 23.1135 16.6249Z",
  fill: "black"
});

function SvgWebAgencies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAgencies);
export default __webpack_public_path__ + "static/media/web_agencies.6aa39513.svg";
export { ForwardRef as ReactComponent };